import { PermissionItem, RolePermission } from "@core/types";

export const PERMISSION: Array<PermissionItem> = [
    {
        id: "Command",
        name: "Command",
        children: [
            { id: RolePermission.COMMAND_REBOOT, name: "Reboot" },
            { id: RolePermission.COMMAND_RESTORE, name: "Restore" },
            { id: RolePermission.COMMAND_UPGRADE_FW, name: "Upgrade FW" },
            { id: RolePermission.COMMAND_UPGRADE_CFG, name: "Upgrade CFG" },
            { id: RolePermission.COMMAND_BACKUP_CFG, name: "Backup CFG" },
            { id: RolePermission.COMMAND_DIAGNOSTIC, name: "Diagnostic" },
            { id: RolePermission.COMMAND_CBSD, name: "CBSD" }
        ]
    },
    {
        id: "Device",
        name: "Device",
        children: [
            { id: RolePermission.DEVICE_CFG, name: "CFG" },
            { id: RolePermission.DEVICE_ANALYSIS, name: "Analysis" },
            { id: RolePermission.DEVICE_EDIT, name: "Edit Info" },
            { id: RolePermission.DEVICE_REMOTE_ACCESS, name: "Remote Access" },
            { id: RolePermission.DEVICE_DELETE, name: "Delete Device" }
        ]
    },
    {
        id: "View",
        name: "View",
        children: [
            { id: RolePermission.VIEW_ANALYTICS, name: "Analytics" },
            { id: RolePermission.VIEW_CELL_ANALYSIS, name: "Cell Analysis" },
            { id: RolePermission.VIEW_SCHEDULER, name: "Scheduler" },
            { id: RolePermission.VIEW_PROFILE_TEMPLATE, name: "Profile Template" },
            { id: RolePermission.VIEW_FILE_MANAGEMENT, name: "Files Management" },
            { id: RolePermission.VIEW_REPORT, name: "Report" },
            { id: RolePermission.VIEW_MAP, name: "Map" }
        ]
    },
    {
        id: "Feature",
        name: "Feature",
        children: [
            { id: RolePermission.FEATURES_ALERT, name: "Alert" },
            { id: RolePermission.FEATURES_REST_API, name: "API" },
            { id: RolePermission.FEATURES_WEBHOOK, name: "Webhooks" },
        ]
    },
    {
        id: "Config",
        name: "Configuration",
        children: [
            { id: RolePermission.CONFIG_INTERFACE, name: "Interface" },
            { id: RolePermission.CONFIG_DUAL_WAN, name: "Dual-Wan" },
            { id: RolePermission.CONFIG_WIFI, name: "Wi-Fi" },
            { id: RolePermission.CONFIG_ACCESS_MANAGEMENT, name: "Access Management" },
            { id: RolePermission.CONFIG_MAINTENANCE, name: "Maintenance" },
            { id: RolePermission.CONFIG_ADVANCED_SETUP, name: "Advanced Setup" },
            { id: RolePermission.CONFIG_VPN, name: "VPN" }
        ]
    }
];